import React, { useEffect } from 'react';
import { useMetasiteError } from '../context/errors';
import { useBiLogger } from '../hooks/useBiLogger/useBiLogger';
import { DsBuilderMethod } from '../types';
import { GeneralError } from '../components/GeneralError/GeneralError';

import { TemplateSelectionRoot } from '../features/templateSelection';
import { useLocalStorageSync } from '../hooks/useLocalStorageSync';

type TemplateSelectionPageProps = {};

export const TemplateSelection: React.FC<TemplateSelectionPageProps> = () => {
  const metasiteError = useMetasiteError();

  useLocalStorageSync({
    syncKeys: ['selectedCategory'],
  });

  const biLogger = useBiLogger();

  useEffect(() => {
    biLogger.pageView(DsBuilderMethod[DsBuilderMethod.TEMPLATE_SELECTION]);
  }, []);

  if (metasiteError) {
    return <GeneralError />;
  }

  return <TemplateSelectionRoot />;
};
